import { infiniteListContextFactory } from './infinite-list-context-factory'
import { useMundiRequest } from './use-mundi-request'

export const { useInfiniteList: useMundiInfiniteList, InfiniteListProvider: MundiInfiniteListProvider } =
  infiniteListContextFactory<any, any>(useMundiRequest)
